{
  "noAssignedModeling": "No assigned project",
  "modelings": "projects",
  "pleaseSignIn": "Please sign in",
  "email": "Email",
  "enterLogin": "Enter UserName",
  "signIn": "Sign in",
  "password": "Password",
  "enterPassword": "Enter password",
  "filterByName": "Filter by name",
  "settings": "Settings",
  "logout": "Logout",
  "home": "Home",
  "users": "Users",
  "areas": "Areas",
  "modelingName": "Project name",
  "passwordChange": "Password change",
  "close": "Close",
  "confirm": "Confirm",
  "userDelete": "Delete user",
  "wannaDeleteThisUser": "Are you sure you want to delete this user?",
  "delete": "Delete",
  "modelingDelete": "Delete project",
  "wannaDeleteThisModeling": "Are you sure you want to delete this project?",
  "userCreation": "User creation",
  "create": "Create",
  "name": "Name",
  "enterUserName": "Enter user name",
  "loginName": "Login name",
  "role": "Role",
  "chooseRole": "Choose role",
  "viewer": "Viewer",
  "admin": "Admin",
  "team": "Team",
  "teamName": "Team name",
  "group": "Group",
  "groups": "Groups",
  "chooseGroup": "Choose group",
  "choose": "Choose",
  "groupCreation": "Group creation",
  "enterGroupName": "Enter group name",
  "groupDetail": "Group detail",
  "save": "Save",
  "userDetail": "User detail",
  "modelingCreation": "Project creation",
  "modelingDetail": "Project detail",
  "datasetList": "Datasets",
  "assetTypeList": "Assets",
  "activityList": "Activities",
  "lifeCycleList": "Life Cycles",
  "description": "Description",
  "benefitList": "Benefits",
  "forecastList": "Forecasts",
  "budgetList": "Budgets",
  "performanceList": "Performances",
  "activityDelete": "Activity delete",
  "wannaDeleteThisActivity": "Are you sure you want to delete this activity?",
  "lifeCycleDelete": "Life Cycle delete",
  "wannaDeleteThisLifeCycle": "Are you sure you want to delete this Life Cycle?",
  "benefitDelete": "Benefit delete",
  "wannaDeleteThisBenefit": "Are you sure you want to delete this benefit?",
  "performanceDelete": "Performance delete",
  "wannaDeleteThisPerformance": "Are you sure you want to delete this performance?",
  "unit": "Unit",
  "unitCost": "Unit cost",
  "rootActivity": "Root activity",
  "activityColor": "Activity color",
  "activityCreate": "Activity create",
  "activityDetail": "Activity detail",
  "costFactor": "Cost factor",
  "benefitCreate": "Benefit create",
  "benefitAttributes": "Benefit attributes",
  "weight": "Weight",
  "biggerMoreBenefit": "Bigger more benefit",
  "mandatoryActAttr": "Mandatory Act Attribute",
  "mandatoryActYearAttr": "Mandatory Act Yearly Attribute",
  "performance": "Performance",
  "performanceName": "Performance name",
  "performanceDescription": "Performance description",
  "performanceLifespan": "Performance lifespan",
  "performanceRanges": "Performance Ranges",
  "startTheoreticalAge": "Start Theoretical Age",
  "endTheoreticalAge": "End Theoretical Age",
  "startAssetPerformance": "Start Asset Performance",
  "endAssetPerformance": "End Asset Performance",
  "startIAPP": "Start IAPP",
  "endIAPP": "End IAPP",
  "color": "Color",
  "lifeCycleActivities": "Life Cycle Activities",
  "activityName": "Activity name",
  "activityUnitCost": "Activity Unit Cost",
  "activityCostFactor": "Activity Cost Factor",
  "minAge": "Min age",
  "maxAge": "Max age",
  "noAct": "No act",
  "significant": "Significant",
  "effect": "Effect",
  "changeToLifeCycleId": "Change to Life Cycle Id",
  "notFirst": "Not first",
  "root": "Root",
  "lifeCycleFilters": "Life Cycle filters",
  "sign": "Sign",
  "number": "Number",
  "lifeCycleCreate": "Life Cycle create",
  "lifeCycleDetail": "Life Cycle detail",
  "activity": "Activity",
  "datasetDetail": "Dataset detail",
  "addAssetType": "Add Asset",
  "addPerformance": "Add Performance",
  "addBenefit": "Add Benefit",
  "addLifeCycle": "Add Life Cycle",
  "addDataset": "Add Dataset",
  "addBudget": "Add Budget",
  "addForecast": "Add Forecast",
  "addActivity": "Add Activity",
  "addCostFactor": "Add Cost Factor",
  "inputModel": "Input model",
  "analysis": "Analysis",
  "results": "Results",
  "datasetCreate": "Dataset create",
  "assetTypeDetail": "Asset detail",
  "forecastCreate": "Forecast create",
  "assetTypeCreate": "Asset create",
  "budgetCreate": "Budget create",
  "budgetDetail": "Budget detail",
  "performanceCreate": "Performance create",
  "performanceDetail": "Performance detail",
  "select": "Select",
  "signif": "Signif.",
  "changeToLifeCycle": "Change to Life Cycle",
  "benefitDetail": "Benefit detail",
  "back": "Back",
  "assetType": "Asset Type",
  "incorrectUserOrPassword": "Incorrect UserName Or Password",
  "startYear": "Start Year",
  "endYear": "End Year",
  "inflationRate": "Inflation Rate",
  "discountRate": "Discount Rate",
  "forecastAssetTypes": "Asset",
  "assetTypes": "Assets",
  "assetAttr": "Asset Attribute",
  "ageAttr": "Age Attribute",
  "dataset": "Dataset",
  "lifeCycles": "Life Cycles",
  "forecastAssetTypeLifeCycles": "Life Cycles",
  "addAssetTypeLifeCycle": "Add Life Cycle",
  "forecastUpdate": "Forecast Update",
  "mandatoryVariants": "Mandatory Variants",
  "forecast": "Forecast",
  "allowBreakLifecycleVariants": "Allow break Life Cycle variants",
  "unlimitedBudget": "Unlimited budget",
  "frameworkBudget": "Framework budget",
  "packageDescription": "Package description",
  "budgetPackages": "Budget Packages",
  "predictiveYear": "Predictive Year",
  "map": "Map",
  "data": "Data",
  "Upload": "Upload",
  "attribute": "Attribute",
  "value": "Value",
  "budget": "Budget",
  "budgetYearly": "Yearly budget",
  "percentage": "Percentage",
  "inputType": "Input type",
  "inputValue": "Input value",
  "showYearlyBudgetPackages": "Show yearly budget",
  "budgetDelete": "Budget Delete",
  "wannaDeleteThisBudget": "Are you sure you want to delete this budget?",
  "datasetDelete": "Dataset Delete",
  "wannaDeleteThisDataset": "Are you sure you want to delete this dataset?",
  "budgetAssetTypes": "Budget Assets",
  "lifeCycle": "Life Cycle",
  "budgetPackage": "Budget Package",
  "benefitWeight": "Benefit Weight",
  "none": "None",
  "leading": "Leading",
  "alias": "Alias",
  "headerName": "Header name",
  "infosetAttributes": "InfoSet Attributes",
  "assetAttribute": "Asset Attribute",
  "lifeCycleAgeAttribute": "Life Cycle Age Attribute",
  "weightAttribute": "Weight Attribute",
  "selectionDetail": "Selection detail",
  "packages": "Packages",
  "limits": "Limits",
  "filterAttributeName": "Filter Attribute Name",
  "filterSign": "Filter Sign",
  "filterValue": "Filter Value",
  "limitDetail": "Limit Detail",
  "package": "Package",
  "selectionLimitPackages": "Selection Limit Packages",
  "years": "Years",
  "limit": "Limit",
  "totalLimitValue": "Total Limit Value",
  "limitValue": "Limit Value",
  "selectionInfo": "Selection Info",
  "selectionMethod": "Selection Method",
  "detail": "Detail",
  "addGroup": "Add Group",
  "addPackage": "Add Package",
  "addLimit": "Add Limit",
  "selectionDelete": "Selection Delete",
  "wannaDeleteThisSelection": "Are you sure you want to delete this selection?",
  "analysisSelection": "Analysis Selection",
  "addSelection": "Add Selection",
  "selectionAreaAssetTypes": "Selection Area Assets",
  "groupCreate": "Group Create",
  "packageLifeCycleViewModel": "Package Life Cycles",
  "inputMethod": "Input Method",
  "packageCreate": "Package Create",
  "packageDetail": "Package Detail",
  "unlimited": "Unlimited",
  "benefit": "Benefit",
  "custom": "Custom",
  "yearly": "Yearly",
  "divided": "Divided",
  "limitCreate": "Limit Create",
  "selectionCreate": "Selection Create",
  "selectionPackageDelete": "Selection Package Delete",
  "wannaDeleteThisSelectionPackage": "Are you sure you want to delete this selection package?",
  "selectionLimitDelete": "Selection Limit Delete",
  "wannaDeleteThisSelectionLimit": "Are you sure you want to delete this selection limit?",
  "selectionGroupDelete": "Selection Area Delete",
  "wannaDeleteThisSelectionGroup": "Are you sure you want to delete this selection area?",
  "performanceRangesChart": "Performance Ranges Chart",
  "lifeCycleActivitiesChart": "Life Cycle Activities Chart",
  "forecastName": "Forecast Name",
  "selectionName": "Selection Name",
  "selectionStartYear": "Selection Start Year",
  "selectionEndYear": "Selection End Year",
  "createdDate": "Created Date",
  "simulation": "Simulation",
  "wannaRunSimulation": "Are you sure you want to run this simulation?",
  "runSimulation": "Run Simulation",
  "export": "Export",
  "selectionLimitPackageYears": "Selection Limit Package Years",
  "benefitSpecification": "Benefit Specification",
  "testingSection1": "Testing Section 1",
  "testingSection2": "Testing Section 2",
  "copy": "Copy",
  "forecastCopy": "Forecast Copy",
  "wannaCopyThisForecast": "Are you sure you want to copy this forecast?",
  "validation": "Validation",
  "validate": "Validate",
  "import": "Import",
  "datasets": "Datasets",
  "upload": "Upload",
  "forecasts": "Forecasts",
  "selections": "Selections",
  "modelingImport": "Project Import",
  "areaCreation": "Area creation",
  "areaDetail": "Area detail",
  "addArea": "Add Area",
  "areaCreate": "Area Create",
  "area": "Area",
  "modelingResultDetail": "Project Result Detail",
  "limitName": "Limit Name",
  "conditions": "Conditions",
  "spending": "Spending",
  "resultDelete": "Result Delete",
  "wannaDeleteThisResult": "Are you sure you want to delete this project result?",
  "modelingResult": "Modeling result",
  "forecastDelete": "Forecast delete",
  "wannaDeleteThisForecast": "Are you sure you want to delete this forecast?",
  "dependencies": "Dependencies",
  "cannotDeleteActivity": "Cannot be deleted, Activity is used in Life Cycle: ",
  "cannotDeleteBenefit": "Cannot be deleted, Benefit is used in Selection Package: ",
  "cannotDeletePerformance": "Cannot be deleted, Performance is used in Life Cycle: ",
  "cannotDeleteLifeCycle": "Cannot be deleted, Life Cycle is used in Forecast: ",
  "cannotDeleteDataset": "Cannot be deleted, Dataset contains Assets.",
  "cannotDeleteAssetType": "Cannot be deleted, Asset is used in Forecast: ",
  "assetTypeDelete": "Asset delete",
  "wannaDeleteThisAssetType": "Are you sure you want to delete this Asset?",
  "allDataWillBeLost": "All data will be lost.",
  "cannotDeleteSelection": "Cannot be deleted, Selection is used in project result: ",
  "loading": "Loading",
  "assetTypeNotEmpty": "Cannot be deleted, Asset is not empty.",
  "selectionNotEmpty": "Cannot be deleted, Selection is not empty.",
  "selectionAreaDelete": "Selection Area delete",
  "activityUpdated": "Activity successfully updated!",
  "datasetUpdateSucessfull": "Dataset was successfully updated",
  "assetTypeUpdated": "Asset succesfully updated!",
  "assetTypeInfosetUpdated": "Asset infoset successfully updated!",
  "emptyName": "Name must be filled in!",
  "benefitUpdated": "Benefit successfully updated!",
  "filesUploaded": "Files were successfully uploaded.",
  "errorWhileUploadingFiles": "Error while uploading files",
  "errorWhileUploadingFilesWrongType": "Error while uploading files. Wrong file type used. (required: .xlsx, .shp, .dbf, .shx)",
  "forecastCopied": "Forecast successfully copied!",
  "errorStartEndYearForecast": "Error when creating Forecast, start year and end year of the Forecast must be filled in!",
  "forecastUpdated": "Forecast succesfully updated",
  "lifeCycleUpdated": "Life Cycle successfully updated",
  "missingPerformanceWarning": "Error when creating Life Cycle, no Performance is selected!",
  "filtersWarning": "Life Cycle Filters contain attribute that has been removed or is not filled",
  "filtersError": "Life Cycle Filters contain attribute that is not filled!",
  "activitiesError": "Life Cycle Activities contain attribute that is not filled!",
  "modelingUpdated": "Project successfully updated!",
  "importSuccess": "Import has been successful!",
  "importError": "Unable to import project, dependent Assets not selected!",
  "lifespanError": "End theoretical age is bigger than lifespan!",
  "performanceUpdated": "Performance successfully updated!",
  "selectionGroupCreated": "Selection group successfully created!",
  "selectionGroupError": "Error while creating selection group!",
  "selectionGroupUpdated": "Selection group successfully updated",
  "selectionGroupErrorUpdate": "Error while updating selection group",
  "selectionLimitCreated": "Selection limit successfully created!",
  "selectionLimitError": "Error while creating selection limit!",
  "selectionLimitUpdated": "Selection limit successfully updated",
  "selectionLimitErrorUpdate": "Error while updating selection limit",
  "limitPackagesMissingValues": "Selection Limit Packages are missing values!",
  "selectionPackageCreated": "Selection package successfully created!",
  "selectionPackageError": "Error while creating selection package!",
  "selectionPackageUpdated": "Selection package successfully updated!",
  "selectionPackageErrorUpdate": "Error while updating selection package!",
  "selectionCreated": "Selection successfully created!",
  "selectionError": "Error while creating selection",
  "selectionUpdated": "Selection successfully updated!",
  "selectionErrorUpdate": "Error while updating selection",
  "groupUpdated": "Group successfully updated!",
  "userUpdated": "User successfully updated!",
  "warningAttributeRemoved": "Form contains attribute that has been removed, please change it!",
  "success": "Success!",
  "error": "Error!",
  "warning": "Warning!",
  "wannaDeleteThisSelectionArea": "wannaDeleteThisSelectionArea",
  "allowNotFirstVariants": "Allow not first variants",
  "coreBenefitMethod": "Core Benefit Method",
  "significantNumber": "Significant Number",
  "fromStatusAsset": "From Status Asset",
  "toStatusAsset": "To Status Asset",
  "classificationOfAssetAttribute": "Classification of Asset Attribute",
  "recalculateLifeCycleAge":" Recalculate Life Cycle Age",
  "assetAttributeYear": "Asset Attribute Year",
  "mandatoryActCostAttr": "Mandatory Act Cost Attribute",
  "parameters": "Parameters",
  "addParameter": "Add Parameter",
  "addCurve": "Add Curve",
  "parameterCreate": "Parameter create",
  "parameterDetail": "Parameter detail",
  "parameterAttributeYear": "Parameter Attribute Year",
  "parameterAttribute": "Parameter Attribute",
  "toTheResults": "To the results",
  "startClassification": "Start Classification",
  "endClassification": "End Classification",
  "parameterUpdated": "Parameter updated",
  "parameterClasses": "Parameter Classes",
  "evaluation": "Evaluation",
  "addEvaluation": "Add Evaluation",
  "classTransformation": "Class Transformation",
  "evaluationFilter": "Evaluation Filter",
  "evaluationCreate": "Evaluation Create",
  "evaluationDetail": "Evaluation Detail",
  "className": "Class Name",
  "startParameter": "Start Parameter",
  "endParameter": "End Parameter",
  "curveDetail": "Curve Detail",
  "curveCreate": "Curve Create",
  "curve": "Curve",
  "curveRange": "Curve Range",
  "curveFilters": "Curve Filters",
  "curveActivityEffects": "Curve Activity Effects",
  "startAge": "Start Age",
  "endAge": "End Age",
  "startValue": "Start Value",
  "endValue": "End Value",
  "changeToCurve": "Change to Curve",
  "curveUpdated": "Curve updated",
  "curveErrorUpdate": "Error while updating curve",
  "curveCreated": "Curve created",
  "curveError": "Error while creating curve",
  "kpi": "KPI",
  "addKpi": "Add KPI",
  "kpiClassification": "KPI Classification",
  "kpiCreate": "KPI Create",
  "kpiDetail": "KPI Detail",
  "evaluationMethod": "Evaluation Method",
  "kpiUpdated": "KPI updated",
  "evaluationParameters": "Evaluation parameters",
  "evaluationFilters": "Evaluation filters",
  "useAttribute": "Use attribute",
  "parameter": "Parameter",
  "additionalProportion": "Additional Proportion",
  "increasingValue": "Increasing Value",
  "recalculateWeight": "Recalculate Weight",
  "weightAverage": "Weight Average",
  "multiply": "Multiply",
  "evaluationCreated": "Evaluation created",
  "evaluationUpdated": "Evaluation updated",
  "evaluationError": "Error while creating evaluation",
  "evaluationErrorUpdate": "Error while updating evaluation",
  "sumarizedCostCharts": "Sumarized Cost Charts",
  "activityPlan": "Activity Plan",
  "resultVisualization": "Result Visualization",
  "weightedAverageCharts": "Weighted Average Charts",
  "distributionCharts": "Distribution Charts",
  "activityCharts": "Activity Charts",
  "resultCharts": "Result Charts",
  "weightAverageCharts": "Weight Average Charts",
  "projectResult": "Project Result",
  "visualization": "Visualization",
  "dataValues": "Data values",
  "year": "Year",
  "currency": "Currency",
  "curveDelete": "Curve Delete",
  "wannaDeleteThisCurve": "Are you sure you want to delete this curve?",
  "parameterDelete": "Parameter Delete",
  "wannaDeleteThisParameter": "Are you sure you want to delete this parameter?",
  "downloadZip": "Download Zip",
  "allGroups": "All groups",
  "totalPackageCost": "Total Package Cost",
  "summarizedCostCharts": "Summarized Cost Charts",
  "allAreas": "All areas",
  "parameterandkpi": "Parameter and KPI",
  "visualizationValue": "Visualization Value",
  "coefficientAttribute": "Coefficient Attribute",
  "coefficientForecastOnly": "Coefficient Forecast Only",
  "curveRangeChart": "Curve Range Chart",
  "evaluationDelete": "Evaluation Delete",
  "wannaDeleteThisEvaluation": "Are you sure you want to delete this evaluation?",
  "legend": "Legend",
  "cannotDeleteKeyPerformanceIndicator": "Cannot be deleted because it is used by the following evaluations: ",
  "kpiDelete": "KPI Delete",
  "wannaDeleteThisKeyPerformanceIndicator": "Are you sure you want to delete this KPI?",
  "allPackages": "All Packages",
  "resultFailed": "Result failed",
  "analysisStarted": "Analysis has been started successfully!",
  "modelingResultDeleted": "Modeling result successfully deleted!",
  "wannaDeleteThisModelingResult": "Are you sure you want to delete this modeling result?",
  "parameterContainsCurves": "This parameter contains curves and cannot be deleted.",
  "parameterContainsEvaluation": "This parameter contains evaluations and cannot be deleted."
}
